"use client";

import useSWR, { mutate } from "swr";

import { API_URLS, MAX_RETRIES } from "./constants";
import { fetcher } from "./utils";

export const revalidateCourse = (publicationId?: string, unitId?: string) =>
  mutate((key) =>
    Array.isArray(key) &&
    key[ 0 ] === API_URLS.COURSE &&
    key[ 1 ] === publicationId &&
    key[ 2 ] === unitId);

export const useCourseData = <T>(
  publicationid?: string,
  unitid?: string,
  link?: string,
  url: string = API_URLS.COURSE,
) => {
  return useSWR<T>(
    !publicationid || !unitid ?
      null :
      // Ключ кэша не зависит от url, чтобы revalidateCourse работал для любой ручки курса
      [
        API_URLS.COURSE,
        publicationid,
        unitid,
        link ?? "",
      ],
    () =>
      fetcher<T>({
        url,
        params: {
          publicationid: publicationid!,
          unitid: unitid!,
          ...(link ?
            { link } :
            {}),
        },
      }),
    {
      errorRetryCount: MAX_RETRIES,
    },
  );
};
